import { PartyFormValues } from './Types/partyTypes';

export const partyInitialValues: PartyFormValues = {
  partyType: 'organization',
  organizationName: '',
  taxId: '',
  regon: '',
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  street: '',
  city: '',
  postalCode: '',
  countryCode: '',
};

